import { createHelpers } from 'vuex-map-fields';

import {
  CARELEVEL_UPDATE_ANSWER,
  CARELEVEL_UPDATE_INPUT_VALUES,
  CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE,
  CARELEVEL_RESET_MODULE_ANSWERS,
  CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS,
  CARELEVEL_REQUEST,
  CARELEVEL_CLEAR_WIZARD,
  CARELEVEL_SET_TRACKING_UUID,
} from '../actions/careLevelCalculator';

import wizard from '@/content/services/CareLevelCalculator/modules';

const { getCareLevelCalculatorField, updateCareLevelCalculatorField } = createHelpers({
  getterType: 'getCareLevelCalculatorField',
  mutationType: 'updateCareLevelCalculatorField',
});

function createEmptyActiveWizardAnswers() {
  const activeWizardAnswers = [];
  wizard.map((w, i) => {
    activeWizardAnswers[i] = [];
    w.questions.map((q, k) => {
      activeWizardAnswers[i][k] = null;
    });
  });
  return activeWizardAnswers;
}

const activeWizardAnswers = createEmptyActiveWizardAnswers();

const wizardModuleWitInputCounter = wizard
  .filter((w) => w.module === 5)[0]
  .questions.filter((q) => q.withInputCounter);

const activeCounterInputValues = [];
wizardModuleWitInputCounter.map(() => {
  activeCounterInputValues.push(0);
});

const wizardIsFinished = false;

const modulePoints = [];

const state = {
  /**
   * Ausgewählte Antworten werden hier gespeichert.
   * Der Index des Array spiegelt das Modul wieder
   */
  activeWizardAnswers,

  /**
   * Modul 5:
   * Auf der Modulübersicht kann der User die Anzahl eigeben, wie häufig
   * Unterstützung benötigt wird. Die Zahl wird hier als Integer gespeichert.
   * Welche Auswahl (Radiobutton) gewählt wurde, wird im state "overViewRadioButtons"
   * gespeichert.
   */
  activeCounterOverviewInputValue: [0, 0, 0],

  /**
   * Modul 5:
   * Anzahl, die vom User ausgewählt wurde, wird als Integer
   * im Array gespeichert. Der Index des Arrays ist dabei das Modul
   */
  activeCounterInputValues,

  /**
   * In jeder Modulübersicht wird die Auswahl hier gespeichert.
   * Der Index des Array spiegelt das Modul wieder
   */
  overViewRadioButtons: new Array(wizard.length).fill(null),

  /**
   * Nur nötig für die Vor und Zurück Navigation
   */
  lastVisitedWizardStep: 0,

  /**
   * Wizard wurde durchlaufen
   */
  wizardIsFinished,

  /**
   * Status des aktuellen Wizards
   */
  currentWizardIsComplete: false,

  /**
   * User Eingaben des Wizards zum Zwischenspeichern
   */
  currentWizardUserValue: null,

  /**
   * Berechnete Modulpunkte (normal und gewichtet)
   */
  modulePoints,

  /**
   * Tracking UUID, falls schon ein unregistrierter PGR innert der derz. Sitzung abgeschickt wurde
   */
  trackingUuid: '',

  /**
   * Errechneter Pflegegrad mit Datum
   */

  calculatedCareLevel: null,
  calculatedCareLevelAt: null,
};

const getters = {
  getCareLevelCalculatorField,

  trackingUuid: (state) => {
    return state.trackingUuid;
  },
};

const mutations = {
  updateCareLevelCalculatorField,

  [CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE]: (state, data) => {
    state.activeCounterOverviewInputValue = [...data];
  },

  [CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS]: (state, data) => {
    state.overViewRadioButtons = [...data];
  },

  [CARELEVEL_UPDATE_INPUT_VALUES]: (state, data) => {
    state.activeCounterInputValues = [...data];
  },

  [CARELEVEL_UPDATE_ANSWER]: (state, data) => {
    state.activeWizardAnswers = [...data];
  },

  [CARELEVEL_REQUEST]: (state, data) => {
    state.modulePoints = data.modulePoints;
    state.calculatedCareLevel = data.calculatedCareLevel;
    state.calculatedCareLevelAt = data.calculatedCareLevelAt;
    state.wizardIsFinished = !!data.modulePoints;
    state.currentWizardIsComplete = data.currentWizardIsComplete;
    state.currentWizardUserValue = data.currentWizardUserValue;
  },

  [CARELEVEL_CLEAR_WIZARD]: (state) => {
    state.activeWizardAnswers = createEmptyActiveWizardAnswers();
    state.wizardModuleWitInputCounter = wizardModuleWitInputCounter;
    state.activeCounterInputValues = activeCounterInputValues;
    state.activeCounterOverviewInputValue = [0, 0, 0];
    state.overViewRadioButtons = new Array(wizard.length).fill(null);
  },

  [CARELEVEL_SET_TRACKING_UUID]: (state, uuid) => {
    state.trackingUuid = uuid;
  },
};

const actions = {
  [CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE]: ({ commit }, data) => {
    const { contentIdx, value } = data;
    const newState = state.activeCounterOverviewInputValue;
    newState[contentIdx] = value;

    commit(CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE, newState);
  },

  [CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS]: ({ commit, state }, data) => {
    const { currentModule, contentIdx, value } = data;
    const newState = state.overViewRadioButtons;
    newState[currentModule] = { ...newState[currentModule], [contentIdx]: value };

    commit(CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS, newState);
  },

  [CARELEVEL_RESET_MODULE_ANSWERS]: ({ commit, state }, data) => {
    const { currentModule } = data;
    const newState = state.activeWizardAnswers;

    const nullArray = [];
    newState[currentModule].map(() => {
      nullArray.push(null);
    });

    newState[currentModule] = nullArray;

    commit(CARELEVEL_UPDATE_ANSWER, newState);
  },

  [CARELEVEL_UPDATE_INPUT_VALUES]: ({ commit, state }, data) => {
    const { question, value } = data;
    const newState = state.activeCounterInputValues;
    newState[question] = value;

    commit(CARELEVEL_UPDATE_INPUT_VALUES, newState);
  },

  [CARELEVEL_UPDATE_ANSWER]: ({ commit, state }, data) => {
    const { currentModule, question, index } = data;
    const newState = state.activeWizardAnswers;
    newState[currentModule][question] = index;

    commit(CARELEVEL_UPDATE_ANSWER, newState);
  },

  [CARELEVEL_REQUEST]: ({ commit }, data) => {
    commit(CARELEVEL_REQUEST, data);
  },

  [CARELEVEL_CLEAR_WIZARD]: ({ commit }) => {
    commit(CARELEVEL_CLEAR_WIZARD);
  },

  [CARELEVEL_SET_TRACKING_UUID]: ({ commit }, data) => {
    commit(CARELEVEL_SET_TRACKING_UUID, data);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
